module.exports = __webpack_public_path__ + "img/pix_white.d429bcee.png";